// Libs
import { Box, Button, Stack, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import { icons } from '~/assets';
import styles from './ReportItem.module.scss';

type Props = {
  icon: ElementType;
  title: string;
  desc?: string;
  type: string;
  onClick?: (type: string) => void;
};

const cx = classNames.bind(styles);

const ReportItem = (props: Props) => {
  //#region Destructuring Props
  const { icon: Icon, onClick, title, type, desc } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/report', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleClick = (type: string) => {
    onClick && onClick(type);
  };
  //#endregion Handle Function

  return (
    <Button sx={{ textAlign: 'left' }} className={cx('reportItemWrap')} onClick={() => handleClick(type)}>
      <Box className={cx('iconWrap')}>
        <Icon />
      </Box>
      <Stack component={'div'} flexDirection={'column'} gap={'8px'} className={cx('midContent')}>
        <Typography className={cx('title')}>{title}</Typography>
        <Typography className={cx('desc')}>{desc}</Typography>
      </Stack>

      <img
        className={cx('iconArrow')}
        src={icons.commonIconBack}
        alt={t('common_alt_img', { ns: 'common/base' })}
      />
    </Button>
  );
};

export default ReportItem;
